/* eslint-disable react/prop-types */
// AddNew.jsx
import React from 'react'
import styles from '../../../../css/compacts.module.css'

const AddNewDefault = function AddNewDefault ({ style }) {
  return (<AddNew style={style} />)
}

export default AddNewDefault

const AddNew = function AddNew ({ style }) {
  return (
    <span
      className={`fa fa-plus-circle ${styles.text}`}
      style={style}
    />
  )
}
